// extracted by mini-css-extract-plugin
export default {"linkIcon":"Qj2tds","secondary":"zc2dKa"};